"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFloodgateFeatureFlagVendor = exports.parseResponse = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const fetch_1 = require("@pandora/fetch");

const types_1 = require("../types");

const utils_1 = require("../utils"); // It will take a Floodgate response and output FeatureFlagValue[]


exports.parseResponse = data => {
  const extractFlags = data => {
    const result = data.releases.filter(release => release.release_name === '||features||');
    return result.length > 0 ? result[0].features : [];
  };

  return extractFlags(data).map(key => {
    return {
      name: key,
      value: true,
      source: types_1.Sources.Floodgate
    };
  });
};

exports.createFloodgateFeatureFlagVendor = config => {
  return features => __awaiter(void 0, void 0, void 0, function* () {
    var _a;

    const f = config.fetch || fetch_1.fetch;
    const headers = {
      'X-Api-Key': config.apiKey
    };

    if (config.getAccessToken) {
      Object.assign(headers, {
        Authorization: `Bearer ${config.getAccessToken()}`
      });
    }

    try {
      const response = yield f(`${config.url}?clientId=${config.clientId}`, {
        headers,
        logger: config.logger
      });
      const data = yield response.json();
      return Promise.resolve(utils_1.mergeFeatureFlagValues(features, exports.parseResponse(data)));
    } catch (e) {
      // In case of error, use previously resolved feature flag values
      (_a = config.logger) === null || _a === void 0 ? void 0 : _a.error(e);
      return Promise.resolve(features);
    }
  });
};